/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';

// where we can only select with number
const textMatcher = ({ filterOption, value: val, filterText }) => {
  const value = val.split(',').join('');
  if (filterText == null) {
    return false;
  }

  switch (filterOption) {
    case 'contains':
      return value.indexOf(filterText) >= 0;
    case 'notContains':
      return value.indexOf(filterText) < 0;
    case 'equals':
      return value === filterText;
    case 'notEqual':
      return value != filterText;
    case 'startsWith':
      return value.indexOf(filterText) === 0;
    case 'endsWith':
      const index = value.lastIndexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};
// when we used to filter number in $ values
const textMatcherAmount = ({ filterOption, value: val, filterText }) => {
  let value = Math.abs(parseFloat(val.split(',').join('')));
  value = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return value.indexOf(filterText) >= 0;
    case 'notContains':
      return value.indexOf(filterText) < 0;
    case 'equals':
      return value === filterText;
    case 'notEqual':
      return value != filterText;
    case 'startsWith':
      return value.indexOf(filterText) === 0;
    case 'endsWith':
      const index = value.lastIndexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

const comparatorQtr = (a, b, nodeA, nodeB, isDescending) => {
  const splittedQtrA = a.split('Q');
  const splittedQtrB = b.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
const comparatorDate = (a, b, nodeA, nodeB, isDescending) => {
  return new Date(a) - new Date(b);
};

export const familyPlanningDrugsPmtRecTableGrid = [
  {
    headerName: 'Quarter',
    field: 'targetQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    comparator: comparatorQtr,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_250,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Payments Received',
    field: 'paymentsReceived',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$',
    isAmount: true,
    exportOption: {
      printWithCurrency: '$',
    },
    cellRenderer: cellRenderer,
    // valueFormatter: dollarFormatter,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Entry Date',
    field: 'drugActivityDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    comparator: comparatorDate,
    minWidth: Styles.Width_200,
    isTextColorRed: true,
    // valueFormatter: dollarFormatter,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
